import type { OrganizationRole } from '../../types'

export const ORGANIZATION_ROLE = {
  DEVELOPER: 'Developer',
  ADMIN: 'Admin',
  OWNER: 'Owner',
} as const satisfies Record<Uppercase<OrganizationRole>, OrganizationRole>

export const VALID_ORGANIZATION_ROLES: OrganizationRole[] = [
  ORGANIZATION_ROLE.DEVELOPER,
  ORGANIZATION_ROLE.ADMIN,
  ORGANIZATION_ROLE.OWNER,
]
